import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col } from "react-bootstrap";
import { IoFunnel } from "react-icons/io5";

import isEmpty from "lodash/isEmpty";

import * as modalActions from "../../actions/modalActions";
import * as userActions from "../../actions/userActions";
import * as projectActions from "../../actions/projectActions";
import * as callActions from "../../actions/callActions";
import * as codeActions from "../../actions/codeActions";

import HeaderWrapper from "../common/HeaderWrapper";
import ProjectList from "./ProjectList";
import FiltersComponent from "../common/FiltersComponent";
import ConfirmModal from "../common/ConfirmModal";

class ProjectPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      search: "",
      defaultPageSize: localStorage.getItem("DEFAULT_PAGE_SIZE_PROJECT_LIST")
        ? parseInt(localStorage.getItem("DEFAULT_PAGE_SIZE_PROJECT_LIST"))
        : 10,
      filters: localStorage.getItem("project-filters")
        ? JSON.parse(localStorage.getItem("project-filters"))
        : {
            search: "",
            customer: [],
            project_manager: [],
            call_type: [],
            project_status: [
              {
                label: "In Process",
                order: 1,
                value: "5ac3ba1ac4621377cb36f07d"
              }
            ],
            department: [],
            category: []
          }
    };
  }

  componentDidMount = () => {
    const { codes, users, actions } = this.props;
    this.props.actions.clearProject();
    if (isEmpty(codes)) {
      actions.loadCodes();
    }
    if (isEmpty(users)) {
      actions.loadUsers();
    }

    if (localStorage.getItem("project-filters")) {
      JSON.parse(localStorage.getItem("project-filters"));
    } else {
      localStorage.setItem(
        "project-filters",
        JSON.stringify(this.state.filters)
      );
    }
  };

  onClickAdd = () => {
    this.props.history.push("/app/projects/add");
  };

  onClickView = (id) => {
    this.props.history.push(`/app/projects/${id}`);
  };

  onClickDelete = (projectId) => {
    this.props.actions.requestProjectId(projectId);
  };

  onPageSizeChange = (pageSize) => {
    localStorage.setItem("DEFAULT_PAGE_SIZE_PROJECT_LIST", pageSize);
  };

  onClickFavorite = async (projectId) => {
    await this.props.actions.updateFavorites(this.props.auth.user, projectId);
    await this.list.table.fireFetchData();
  };

  onSearchFilter = (e) => {
    const search = e.target.value;
    this.setState((prevState) => ({
      filters: { ...prevState.filters, search }
    }));
  };

  handleDelete = async () => {
    await this.props.actions.deleteProject(this.props.projectToDelete);
    await this.list.table.fireFetchData();
  };

  handleChangeFilters = (field, input) => {
    const filters = { ...this.state.filters };
    filters[field] = input;
    this.setState(
      { filters },
      localStorage.setItem("project-filters", JSON.stringify(filters))
    );
  };

  resetFilters = () => {
    this.setState({
      filters: {
        search: "",
        customer: [],
        project_manager: [],
        call_type: [],
        project_status: [],
        department: [],
        category: []
      }
    });
    localStorage.removeItem("project-filters");
  };

  render() {
    const { codes, auth, isMobile } = this.props;
    const { filters, open, defaultPageSize } = this.state;
    return (
      <React.Fragment>
        <HeaderWrapper
          breadcrumbs={[{ label: "Projects" }]}
          onClickAdd={auth.maxRole > 2000 && this.onClickAdd}
          onClickAction={[
            { action: () => this.setState({ open: !open }), icon: <IoFunnel /> }
          ]}
          onFilter={this.onSearchFilter}
          isMobile={isMobile}
        />

        <FiltersComponent
          open={open}
          filters={filters}
          onChangeFilters={this.handleChangeFilters}
          onReset={this.resetFilters}
          fields={[
            "Call Type",
            "Project Manager",
            "Customer",
            "Project Status",
            "Department",
            "Project Category"
          ]}
        />

        <div className="content-wrapper">
          <ProjectList
            serverSide
            ref={(l) => (this.list = l)}
            auth={auth}
            codes={codes}
            filtered={filters}
            isMobile={isMobile}
            defaultPageSize={defaultPageSize}
            onClickView={this.onClickView}
            onClickDelete={this.onClickDelete}
            onClickFavorite={this.onClickFavorite}
            onPageSizeChange={this.onPageSizeChange}
          />
        </div>

        <ConfirmModal
          id="projectDeleteModal"
          title="Delete Project"
          body="Are you sure you want to delete this project?"
          close={this.props.actions.hideModal}
          confirm={this.handleDelete}
        />
      </React.Fragment>
    );
  }
}

ProjectPage.propTypes = {
  isMobile: PropTypes.bool,
  actions: PropTypes.object.isRequired,
  auth: PropTypes.object,
  codes: PropTypes.array,
  projectToDelete: PropTypes.string,
  users: PropTypes.array,
  history: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    auth: state.reducers.auth,
    codes: state.reducers.codes,
    projectToDelete: state.reducers.projectToDelete
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...modalActions,
        ...userActions,
        ...projectActions,
        ...callActions,
        ...codeActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(ProjectPage);
